<div class="mainContainer">
    <app-reg-form-header heading="Create your profile"></app-reg-form-header>
    <div class="main">
        <div class="mx-2 mx-md-4 p-2 mt-2 progressBar" *ngIf="!queryParams.isDisable">
            <app-progress-bar-register [atRegisterForm]='atRegisterForm'></app-progress-bar-register>
        </div>
        <div class="d-flex ustify-content-between mt-2 mb-2 w-100 px-2 px-md-4 box">
            <!-- Menu button enables for small screen (mobile) -->
            <div class="me-2 d-block d-sm-none">
                <i class="fa fa-bars" (click)="showSideMenu()" style="font-size: 28px;" aria-hidden="true"></i>
            </div>

            <div class="col-3 d-none d-md-block pe-md-3 leftDetailedPanel">
                <app-left-detailed-panel (panelListItem)="panelListItemRes($event)"
                    (isDisableForm)="isDisableFormRes($event)"></app-left-detailed-panel>
            </div>
            <div [ngClass]="showMenu ?  'd-none d-sm-block col-11 col-sm-8 col-md-6 detailedForm height-fix' : 'col-11 col-sm-8 col-md-6 detailedForm height-fix'">
                <app-reg-common-form [inputDataList]="inputDataList" [heading]="heading"
                    (formButtonResEvent)="formButtonResEvent($event)" [submitBtnText]="submitBtnText"
                    showDraftBtn='true' DraftBtnText="SAVE AS DRAFT" formName="detailedRegister"
                    [panelListItem]="panelListItem" [isDisableForm]="isDisableForm" [couponData]="couponData"
                    (couponDetails)="couponDetailsRes($event)">
                </app-reg-common-form>
            </div>
            <div
                [ngClass]="showMenu ? 'paymentSummaryMenu col-11 col-sm-4 col-md-3 ps-0 ps-sm-3' : 'col-sm-4 col-md-3 d-none d-sm-block ps-sm-3 rightDetailedPanel'">
                <!-- <app-profile-progress></app-profile-progress> -->
                <app-payment-summary (couponData)="couponAppliedRes($event)"
                    [appliedCouponDetails]="appliedCouponDetails"></app-payment-summary>
            </div>
        </div>
    </div>
</div>
<div>
    <app-footer></app-footer>
</div>